import { useState, useEffect, useMemo } from 'react';
import UserAPI from '../apis/UserAPI';
import TreeAPI from '../apis/TreeAPI';

const useEpisodes = (userId = undefined) => {
  const [episodes, setEpisodes] = useState(undefined);
  const [free, setFree] = useState({});
  const [completed, setCompleted] = useState({});
  const [purchases, setPurchases] = useState({});

  useEffect(() => {
    const unsubscribe = TreeAPI.subscribeToEpisodes(
      (episode) =>
        setEpisodes((state) => ({ ...state, [episode.id]: episode })),
      (key) => setEpisodes((state) => ({ ...state, [key]: undefined }))
    );
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const unsubscribe = TreeAPI.subscribeToFreeEpisodes(
      (key) => setFree((state) => ({ ...state, [key]: true })),
      (key) => setFree((state) => ({ ...state, [key]: undefined }))
    );
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    setCompleted({});
    const unsubscribe = UserAPI.subscribeToCompletedEpisodes(
      (episodeId) => setCompleted((state) => ({ ...state, [episodeId]: true })),
      (episodeId) =>
        setCompleted((state) => ({ ...state, [episodeId]: undefined })),
      userId
    );
    return () => unsubscribe();
  }, [userId]);

  useEffect(() => {
    setPurchases({});
    const unsubscribe = UserAPI.subscribeToPurchases(
      (episodeId) => setPurchases((state) => ({ ...state, [episodeId]: true })),
      (episodeId) =>
        setPurchases((state) => ({ ...state, [episodeId]: undefined })),
      userId
    );
    return () => unsubscribe();
  }, [userId]);

  const episodesArray = useMemo(() => {
    if (!episodes) return undefined;
    const arr = Object.keys(episodes)
      .filter((key) => episodes[key] !== undefined)
      .map((key) => episodes[key])
      .sort((a, b) => a.order - b.order);

    return arr.map((episode) => ({
      ...episode,
      free: free[episode.id],
      completed: completed[episode.id],
      purchased: purchases[episode.id],
    }));
  }, [episodes, free, completed, purchases]);

  return episodesArray;
};

export { useEpisodes };
